module.exports = __webpack_public_path__ + "static/media/02.50ba488b.gif";